import {LobbyImage} from '@colonist/types'
import {type TranslationObject} from '@colonist/i18n'
import {type UIMMatchmakingController} from './UIMMatchmakingController.ts'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView.ts'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

export class UIMMatchmakingSearchingCnKView extends UIMMatchmakingSearchingView<MatchmakingMatchTypes.RankedCitiesAndKnights4P> {
    constructor(matchmakingController: UIMMatchmakingController) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const title: TranslationObject = {key: 'strings:homePage.matchmakingPopup.rankedCitiesAndKnights.title'}
        const imageSrc = LobbyImage.GameModeCnK

        super(matchmakingController, title, imageSrc, loadingText, MatchmakingMatchTypes.RankedCitiesAndKnights4P)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }
}
